import { action, computed, observable } from 'mobx';
import { IntersectionObserverEntity } from '../domain/entities/IntersectionObserver';

export class StickyWrapperViewController {
    @observable private observedElements: IntersectionObserverEntity[] = [];

    @action
    public initialize = (stickyElementsSelectors: string[]) => {
        if (stickyElementsSelectors && stickyElementsSelectors.length) {
            this.observedElements = stickyElementsSelectors.map((selector) => {
                return new IntersectionObserverEntity(selector);
            });
        }

        this.startObserving();
    };

    @computed
    public get offset() {
        return this.observedElements.reduce(
            (total: number, element: IntersectionObserverEntity) => {
                return total + element.height;
            },
            0
        );
    }

    public startObserving() {
        this.observedElements.forEach((observedElement) => {
            observedElement.observe && observedElement.observe();
        });
    }

    public disconnectObservers() {
        this.observedElements.forEach((observedElement) => {
            observedElement.disconnect && observedElement.disconnect();
        });
    }
}
